(function () {
  /* ── Toggle accordion (does not close siblings) ──────── */
  window.pvToggle = function (btn, sectionId) {
    var wrap = document.getElementById("pv-wrap-" + sectionId);
    if (!wrap) return;
    var isOpen = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
    btn.nextElementSibling.classList.toggle("open", !isOpen);
  };

  /* ── Read picks → find matching variant ────────────────── */
  function pvCurrentVariant(pvEl) {
    if (!pvEl || !pvEl._pvVariants) return null;
    var picks = [];
    pvEl.querySelectorAll("[data-js-product-variant]").forEach(function (g, i) {
      var idx =
        g.dataset.optionIndex != null ? parseInt(g.dataset.optionIndex, 10) : i;
      var radio = g.querySelector(".product-variant__input:checked");
      var select = g.querySelector("select.product-variant-container");
      if (radio) picks[idx] = radio.value;
      else if (select) picks[idx] = select.value;
    });
    return (
      pvEl._pvVariants.find(function (v) {
        return (
          String(v.option1 || "") === String(picks[0] || "") &&
          String(v.option2 || "") === String(picks[1] || "") &&
          String(v.option3 || "") === String(picks[2] || "")
        );
      }) || null
    );
  }

  /* ── Move the css-slider gallery to the selected variant's image ── */
  function pvSwitchGalleryImage(variant, pvEl) {
    if (!variant) return;

    var media = variant.featured_media || variant.featured_image;
    if (!media) return; // variant has no image assigned in admin
    var mediaId = media.id;

    var sectionId = pvEl && pvEl.dataset.id;
    var root =
      (sectionId && document.getElementById("product-" + sectionId)) ||
      (pvEl && pvEl.closest("product-page")) ||
      document;

    var gallery = root.querySelector("[data-js-product-gallery]") || root;
    var slides = gallery.querySelectorAll(".product-gallery-item");
    if (!slides.length) return;

    // Find the target slide: prefer data-media-id, fall back to media position
    var target = null,
      index = -1;
    for (var i = 0; i < slides.length; i++) {
      if (String(slides[i].getAttribute("data-media-id")) === String(mediaId)) {
        target = slides[i];
        index = i;
        break;
      }
    }
    if (!target && media.position) {
      // 1-based position == slide order
      index = media.position - 1;
      target = slides[index] || null;
    }
    if (!target) return;

    // Thumbnails mode: click the matching thumbnail so css-slider drives itself
    var thumb = gallery.querySelector(
      '.product-gallery__thumbnails .thumbnail[data-index="' + index + '"]',
    );
    if (thumb) {
      thumb.click();
      return;
    }

    // Dots mode: scroll the slide into the horizontal viewport (updates dots too)
    var scroller =
      target.closest(".css-slider-viewport") ||
      target.closest(".css-slider-holder") ||
      target.parentElement;
    if (scroller && scroller.scrollWidth > scroller.clientWidth) {
      var s = scroller.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      scroller.scrollTo({
        left: scroller.scrollLeft + (t.left - s.left),
        behavior: "smooth",
      });
    } else {
      target.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }

  /* ── Apply variant to price / id / URL / ATC / gallery ───────────── */
  function pvApplyVariant(sectionId, forced) {
    var pvEl = document.querySelector(
      'product-variants[data-id="' + sectionId + '"]',
    );
    var variant = forced || pvCurrentVariant(pvEl);
    if (!variant) return;

    var fmt = (function () {
      var format = "{{amount}} AED";

      function withDelims(cents, precision, thousands, decimal) {
        precision = precision == null ? 2 : precision;
        thousands = thousands == null ? "," : thousands;
        decimal = decimal == null ? "." : decimal;
        if (isNaN(cents) || cents == null) return "0";
        var n = (cents / 100).toFixed(precision);
        var parts = n.split(".");
        var whole = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands,
        );
        return whole + (parts[1] ? decimal + parts[1] : "");
      }

      return function (cents) {
        var ph = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!ph) return format;
        var value;
        switch (ph[1]) {
          case "amount_no_decimals":
            value = withDelims(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = withDelims(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = withDelims(cents, 0, ".", ",");
            break;
          case "amount_with_apostrophe_separator":
            value = withDelims(cents, 2, "'", ".");
            break;
          case "amount_with_space_separator":
            value = withDelims(cents, 2, " ", ".");
            break;
          case "amount_no_decimals_with_space_separator":
            value = withDelims(cents, 0, " ", ".");
            break;
          default:
            value = withDelims(cents, 2);
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      };
    })();

    var scope =
      pvEl.closest(".product, .product-info, [data-product-id], main") ||
      document;

    /* Price text is ALWAYS owned by the selected variant.
       GPO renders its add-on total separately in .gpo-total-text and never
       writes here; the theme price node does not recompute with this custom
       selector, so JS must be the single source of truth. */
    scope.querySelectorAll("[data-vikst-alt-price]").forEach(function (el) {
      el.innerHTML = fmt(variant.price);
    });

    scope.querySelectorAll("[data-vikst-alt-compare]").forEach(function (el) {
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        var saving = variant.compare_at_price - variant.price;
        el.innerHTML =
          "<span>" +
          fmt(variant.compare_at_price) +
          "</span>" +
          "<span>Save " +
          fmt(saving) +
          "</span>";
      } else {
        el.innerHTML = "";
      }
    });

    scope.querySelectorAll("[data-vikst-alt-unit]").forEach(function (el) {
      if (variant.unit_price && variant.unit_price_measurement) {
        var ref = variant.unit_price_measurement.reference_value;
        var unit = variant.unit_price_measurement.reference_unit;
        el.textContent =
          fmt(variant.unit_price) + " / " + (ref !== 1 ? ref : "") + unit;
      } else {
        el.textContent = "";
      }
    });

    /* Refresh base-price attr so GPO recomputes its total from the new variant */
    scope
      .querySelectorAll(".product-price-alt[data-product-base-price]")
      .forEach(function (el) {
        el.setAttribute("data-product-base-price", variant.price);
      });

    /* Hidden variant id in the MAIN product form only.
       Never rewrite pair-with / quick-buy forms — that would add the
       current product instead of the paired item. */
    var mainFormSelectors =
      '#product-form-' +
      sectionId +
      ' [name="id"], #product-form-installment [name="id"]';
    document.querySelectorAll(mainFormSelectors).forEach(function (i) {
      if (i.closest(".product-pair-with")) return;
      if (i.value !== String(variant.id)) {
        i.value = variant.id;
        i.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    /* URL */
    if (variant.id && window.history && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url.toString());
    }

    /* Gallery → switch to the variant's image */
    pvSwitchGalleryImage(variant, pvEl);

    document.dispatchEvent(
      new CustomEvent("variant:change", {
        detail: { variant: variant, sectionId: sectionId },
      }),
    );
  }

  /* ── Radio change: check icon + apply variant ──────────── */
  window.pvSync = function (input, sectionId) {
    var item = input.closest(".pv-item");
    if (item) {
      var checkEl = item.querySelector("[data-pv-check]");
      var hasPick = !!item.querySelector(".product-variant__input:checked");
      if (checkEl) checkEl.style.display = hasPick ? "" : "none";
    }
    pvResolve(sectionId);
  };

  /* ── >250 variants: resolve via Section Rendering API (?option_values=) ── */
  function pvPicks(pvEl) {
    var values = [],
      ids = [];
    pvEl.querySelectorAll("[data-js-product-variant]").forEach(function (g, i) {
      var idx =
        g.dataset.optionIndex != null ? parseInt(g.dataset.optionIndex, 10) : i;
      var el =
        g.querySelector(".product-variant__input:checked") ||
        (function () {
          var s = g.querySelector("select.product-variant-container");
          return s && s.options[s.selectedIndex];
        })();
      if (!el) return;
      values[idx] = el.value;
      ids[idx] = el.dataset.optionValueId;
    });
    return { values: values, ids: ids };
  }

  function pvApplyState(pvEl, state, picks) {
    if (!state) return;
    var sectionId = pvEl.dataset.id;

    var v = state.variant;
    var exists =
      v &&
      (!picks ||
        picks.values.every(function (val, i) {
          return String(v.options[i]) === String(val);
        }));

    /* Feed the theme's quantity lookup with the resolved variant */
    var qEl = pvEl.querySelector("[data-js-variant-quantity-data]");
    if (qEl && exists && state.quantity != null) {
      var inv = [];
      try {
        inv = JSON.parse(qEl.dataset.inventory) || [];
      } catch (e) {}
      inv = inv.filter(function (i) {
        return i.id !== v.id;
      });
      var entry = { id: v.id, quantity: state.quantity, inventory: state.policy };
      if (!v.available) entry.unavailable = true;
      inv.push(entry);
      qEl.dataset.inventory = JSON.stringify(inv);
      if (pvEl.productStockData) pvEl.productStockData = inv;
    }

    /* Variants past #250 aren't in the theme's JSON, so its own change handler
       resolves nothing and paints "Unavailable". Add the server-resolved
       variant to both caches, then re-run the theme handler. */
    if (exists) {
      [pvEl._pvVariants, pvEl.getVariantData && pvEl.getVariantData()].forEach(
        function (list) {
          if (!list) return;
          for (var i = 0; i < list.length; i++) {
            if (list[i].id === v.id) {
              list[i] = v;
              return;
            }
          }
          list.push(v);
        },
      );
      if (typeof pvEl.onVariantChange === "function") pvEl.onVariantChange();
    }

    /* Cross out option values with no available variant for the current picks
       (after the theme handler, which resets these classes) */
    pvEl.querySelectorAll("[data-option-value-id]").forEach(function (el) {
      var avail = state.values[el.dataset.optionValueId];
      if (avail == null) return;
      el.classList.toggle("disabled", !avail);
    });

    /* No variant for this combo → never leave a stale id in the cart form */
    var scope =
      pvEl.closest(".product, .product-info, [data-product-id], main") ||
      document;
    scope
      .querySelectorAll("[data-js-product-add-to-cart]")
      .forEach(function (b) {
        if (b.closest(".product-pair-with")) return;
        b.disabled = !exists || !v.available;
      });

    if (exists) pvApplyVariant(sectionId, v);
  }

  function pvResolve(sectionId) {
    var pvEl = document.querySelector(
      'product-variants[data-id="' + sectionId + '"]',
    );
    if (!pvEl) return;
    var picks = pvPicks(pvEl);

    /* Instant update when the variant is inside the first 250 */
    var local = pvCurrentVariant(pvEl);
    if (local) pvApplyVariant(sectionId, local);

    var ids = picks.ids.filter(Boolean);
    if (!ids.length) return;
    var req = (pvEl._pvReq = (pvEl._pvReq || 0) + 1);
    var base = pvEl.dataset.url;
    var url =
      base +
      (base.indexOf("?") > -1 ? "&" : "?") +
      "section_id=" +
      encodeURIComponent(sectionId) +
      "&option_values=" +
      ids.join(",");

    fetch(url)
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        if (req !== pvEl._pvReq) return; // stale response
        var doc = new DOMParser().parseFromString(html, "text/html");
        var s = doc.querySelector(
          'product-variants[data-id="' + sectionId + '"] [data-pv-state]',
        );
        if (!s) return;
        pvApplyState(pvEl, JSON.parse(s.textContent), picks);
      })
      .catch(function () {});
  }

  /* ── Init: parse variants FIRST so pvApplyVariant has data to work with ── */
  document.querySelectorAll("product-variants").forEach(function (el) {
    var sectionId = el.dataset.id;
    var wrap = el.querySelector("#pv-wrap-" + sectionId);
    if (!wrap) return;

    var scriptTag = el.querySelector('script[type="application/json"]');
    if (!scriptTag) return;

    var variants;
    try {
      variants = JSON.parse(scriptTag.textContent);
    } catch (e) {
      return;
    }

    el._pvVariants = variants;
    el._pvBase = Math.min.apply(
      null,
      variants.map(function (v) {
        return v.price;
      }),
    );

    wrap.querySelectorAll(".pv-item").forEach(function (item) {
      var header = item.querySelector(".pv-header");
      var body = item.querySelector(".pv-body");
      if (header) header.setAttribute("aria-expanded", "true");
      if (body) body.classList.add("open");

      var checkEl = item.querySelector("[data-pv-check]");
      if (checkEl)
        checkEl.style.display = item.querySelector(
          ".product-variant__input:checked",
        )
          ? ""
          : "none";
    });
  });

  /* ── Now apply the initial variant (price, compare, URL, ATC id, gallery) ── */
  document
    .querySelectorAll("product-variants[data-id]")
    .forEach(function (pvEl) {
      var s = pvEl.querySelector("[data-pv-state]");
      var state = null;
      try {
        state = s && JSON.parse(s.textContent);
      } catch (e) {}
      if (state) pvApplyState(pvEl, state, pvPicks(pvEl));
      else pvApplyVariant(pvEl.dataset.id);
    });

  /* ── Select mode has no inline onchange → delegate ─────── */
  document.addEventListener("change", function (e) {
    var select = e.target.closest("select.product-variant-container");
    if (!select) return;
    var pvEl = select.closest("product-variants[data-id]");
    if (pvEl) pvResolve(pvEl.dataset.id);
  });

  window.pvUpdateFade = function (scrollEl) {
    const wrap = scrollEl.closest(".pv-scroll-wrap");
    if (!wrap) return;
    const atBottom =
      scrollEl.scrollHeight - scrollEl.scrollTop <= scrollEl.clientHeight + 2;
    wrap.classList.toggle("no-fade", atBottom);
  };

  document.querySelectorAll(".pv-scroll").forEach((el) => {
    pvUpdateFade(el);
    el.addEventListener("scroll", () => pvUpdateFade(el), { passive: true });
  });

  document.querySelectorAll(".pv-header").forEach((btn) => {
    btn.addEventListener("click", () => {
      setTimeout(() => {
        document
          .querySelectorAll(".pv-body.open .pv-scroll")
          .forEach(pvUpdateFade);
      }, 300);
    });
  });
})();

(function () {
  var chevronSVG =
    '<svg class="pv-chevron" width="11" height="7" viewBox="0 0 11 7" fill="none"><path d="M1 1L5.5 5.5L10 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function hasSelection(group) {
    if (group.querySelector('input[type="radio"]:checked')) return true;
    if (group.querySelector('input[type="checkbox"]:checked')) return true;
    var sel = group.querySelector("select");
    if (sel && sel.value && sel.selectedIndex > 0) return true;
    return false;
  }

  function updateCheck(group) {
    var el = group.querySelector("[data-gpo-check]");
    if (!el) return;
    el.style.display = hasSelection(group) ? "" : "none";
  }

  function isRequired(group) {
    var label = group.querySelector(".gpo-label");
    return !!(label && label.classList.contains("required"));
  }

  /* ── Toggle accordion (does not close siblings) ──────── */
  function toggleGroup(header) {
    var item = header.closest(".pv-item");
    var body = item.querySelector(".pv-body");
    var isOpen = header.getAttribute("aria-expanded") === "true";
    header.setAttribute("aria-expanded", isOpen ? "false" : "true");
    body.classList.toggle("open", !isOpen);
  }

  function initGroup(group, openIt) {
    if (group.dataset.gpoPvDone) return;
    group.dataset.gpoPvDone = "1";
    group.classList.add("pv-item");
    var label = group.querySelector(".gpo-label");
    if (!label) return;
    var labelContent = label.querySelector(".label-content");
    var title = labelContent
      ? labelContent.textContent.trim()
      : label.textContent.trim();
    var required = label.classList.contains("required");
    var header = document.createElement("button");
    header.type = "button";
    header.className = "pv-header";
    header.setAttribute("aria-expanded", openIt ? "true" : "false");
    var checkSVG =
      '<svg class="pv-check-icon" width="18" height="18" viewBox="0 0 18 18" fill="none"><rect width="18" height="18" rx="3" fill="#2e7d32"/><path d="M4 9L7.5 12.5L14 5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    header.innerHTML =
      '<span class="pv-title">' +
      title.replace(/\s*\(\+[^)]*\)\s*/g, "").trim() +
      (required ? '<span style="color:#eb1256;margin-left:2px">*</span>' : "") +
      "</span>" +
      '<span class="pv-meta">' +
      '<span class="pv-check" data-gpo-check style="display:none">' +
      checkSVG +
      "</span>" +
      chevronSVG +
      "</span>";

    header.addEventListener("click", function () {
      toggleGroup(this);
    });
    var pvBody = document.createElement("div");
    pvBody.className = "pv-body" + (openIt ? " open" : "");
    var node = label.nextSibling;
    while (node) {
      var next = node.nextSibling;
      pvBody.appendChild(node);
      node = next;
    }
    label.style.display = "none";
    group.appendChild(header);
    group.appendChild(pvBody);
    updateCheck(group);
  }

  /* ── Init: open every REQUIRED visible group, leave optional closed ── */
  function initAll() {
    document
      .querySelectorAll(".gpo-element.gpo-form__group")
      .forEach(function (group) {
        if (window.getComputedStyle(group).display === "none") return;
        initGroup(group, isRequired(group));
      });
  }

  /* ── Change handler: just update check + butcher merge logic ── */
  document.addEventListener("change", function (e) {
    var group = e.target.closest(".gpo-element.gpo-form__group");
    if (!group) return;

    updateCheck(group);

    var title =
      group.querySelector(".pv-title") || group.querySelector(".gpo-label");
    var isButcher =
      title && title.textContent.toLowerCase().indexOf("butcher") !== -1;
    if (isButcher) setTimeout(syncButcherMerge, 250);
  });

  function syncButcherMerge() {
    var butcherGroup = null;
    document
      .querySelectorAll(".gpo-app .gpo-element.gpo-form__group")
      .forEach(function (item) {
        var title =
          item.querySelector(".pv-title") || item.querySelector(".gpo-label");
        if (
          title &&
          title.textContent.toLowerCase().indexOf("butcher") !== -1
        ) {
          butcherGroup = item;
        }
      });
    if (!butcherGroup) return;

    var sel = butcherGroup.querySelector("select");
    var isYes = false;
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      isYes = opt && opt.textContent.toLowerCase().indexOf("yes") !== -1;
    }

    var butcherBody = butcherGroup.querySelector(".pv-body");
    if (!butcherBody) return;

    document
      .querySelectorAll(".gpo-app .gpo-element.gpo-form__group")
      .forEach(function (item) {
        if (item === butcherGroup) return;
        var title =
          item.querySelector(".pv-title") || item.querySelector(".gpo-label");
        if (!title) return;
        var text = title.textContent.toLowerCase();

        /* ── Inspect — standalone accordion when butcher = No ── */
        /* ── "Please select if we can open and inspect..." — show/hide only ── */
        /* ── "Please select if we can open and inspect..." ── */
        if (text.indexOf("inspect") !== -1) {
          var inputs = item.querySelectorAll("input, select, textarea");

          if (isYes) {
            item.style.setProperty("display", "none", "important");
            inputs.forEach(function (i) {
              i.disabled = true;
            });
          } else {
            item.style.setProperty("display", "block", "important");
            if (item.getAttribute("data-clo-display") === "hide") {
              item.setAttribute("data-clo-display", "show");
            }

            /* Re-enable what GPO disabled while the group was hidden */
            inputs.forEach(function (i) {
              i.disabled = false;
            });

            /* Wrap in our accordion the first time it appears */
            if (!item.dataset.gpoPvDone) {
              initGroup(item, true);
              updateCheck(item);
            }
          }
          return;
        }

        /* ── Weight + SELECT OPTION — merged into butcher body when Yes ── */
        var isWeight = text.indexOf("weight") !== -1;
        var isSelectOption = text.indexOf("select option") !== -1;
        if (!isWeight && !isSelectOption) return;

        var targetBody = item.querySelector(".pv-body");
        if (!targetBody) return;

        if (isYes) {
          if (item._pvMergedInto !== butcherGroup) {
            var contentWrap = item._pvContentWrap;
            if (!contentWrap) {
              contentWrap = document.createElement("div");
              contentWrap.className = "pv-merge-content";
              while (targetBody.firstChild)
                contentWrap.appendChild(targetBody.firstChild);
              var hiddenLabel = item.querySelector(".gpo-label");
              if (hiddenLabel) contentWrap.appendChild(hiddenLabel);
              item._pvContentWrap = contentWrap;
            }

            var divider = item._pvDivider;
            if (!divider) {
              divider = document.createElement("div");
              divider.className = "pv-butcher-merge";
              divider.style.cssText =
                "margin-top:16px;padding-top:16px;border-top:1px solid #e5e5e5";

              var subLabel = document.createElement("div");
              subLabel.style.cssText =
                "font-weight:600;text-transform:uppercase;font-size:11px;letter-spacing:0.5px;margin-bottom:8px";
              subLabel.textContent = title.textContent
                .replace(/\*$/, "")
                .trim();
              var origLabel = item.querySelector(".gpo-label.required");
              if (origLabel)
                subLabel.innerHTML +=
                  '<span style="color:#eb1256;margin-left:2px">*</span>';
              divider.appendChild(subLabel);
              item._pvDivider = divider;
            }

            divider.appendChild(contentWrap);
            butcherBody.appendChild(divider);
            item._pvMergedInto = butcherGroup;
          }
          item.style.setProperty("display", "none", "important");
        } else {
          var contentWrap = item._pvContentWrap;
          var divider = item._pvDivider;

          if (item._pvMergedInto === butcherGroup) {
            if (contentWrap && targetBody) targetBody.appendChild(contentWrap);
            if (divider && divider.parentNode) divider.remove();
            item._pvMergedInto = null;
          }

          item.style.setProperty("display", "none", "important");
        }
      });
  }

  function watchCLO() {
    var app = document.querySelector(".gpo-app");
    if (!app) return;
    new MutationObserver(function () {
      document
        .querySelectorAll(".gpo-element.gpo-form__group")
        .forEach(function (group) {
          if (
            !group.dataset.gpoPvDone &&
            window.getComputedStyle(group).display !== "none"
          ) {
            initGroup(group, isRequired(group));
          }
          updateCheck(group);
        });
      syncButcherMerge();
    }).observe(app, {
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });
  }

  function syncGPOTotalVisibility() {
    var totalText = document.querySelector(".gpo-total-text");
    var totalWrapper = document.querySelector(".gpo-total.gpo-form__group");
    if (!totalText || !totalWrapper) return;
    totalWrapper.style.display =
      totalText.style.display === "none" ? "none" : "";
  }

  function waitForGPO() {
    var app = document.querySelector(".gpo-app");
    if (!app || !app.querySelector(".gpo-element.gpo-form__group")) {
      setTimeout(waitForGPO, 150);
      return;
    }

    initAll();
    watchCLO();
    syncButcherMerge();
    setTimeout(syncButcherMerge, 500);

    var gpoContainer = app.closest(".gpo-container");
    var pvElement = document.querySelector("product-variants");
    if (gpoContainer && pvElement) {
      pvElement.appendChild(gpoContainer);
    }

    syncGPOTotalVisibility();
    var gpoTotalText = document.querySelector(".gpo-total-text");
    if (gpoTotalText) {
      new MutationObserver(syncGPOTotalVisibility).observe(gpoTotalText, {
        attributes: true,
        attributeFilter: ["style"],
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", waitForGPO);
  } else {
    waitForGPO();
  }
})();

// free shipping
(function () {
  var NS = "VIKSTFreeShipBar";

  function formatAmount(cents) {
    return Math.max(0, Math.floor(cents / 100)).toLocaleString("en-US");
  }

  function renderInstance(inst, subtotal) {
    var remaining = Math.max(0, inst.threshold - subtotal);
    var pct = Math.min(100, Math.max(0, (subtotal / inst.threshold) * 100));

    if (inst.fill) inst.fill.style.width = pct + "%";
    if (inst.amount) {
      var currency = inst.root.dataset.currency || "AED";
      var thresholdUnits = formatAmount(inst.threshold);
      var subtotalUnits = formatAmount(subtotal);
      inst.amount.textContent =
        subtotalUnits + "/" + thresholdUnits + " " + currency;
    }
  }

  function renderAll(subtotal) {
    INSTANCES.forEach(function (inst) {
      if (!document.body.contains(inst.root)) return;
      renderInstance(inst, subtotal);
    });
  }

  function fetchSubtotal() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        LAST_SUBTOTAL = cart.items_subtotal_price || 0;
        renderAll(LAST_SUBTOTAL);
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(PENDING);
    PENDING = setTimeout(fetchSubtotal, 120);
  }

  function addInstance(root) {
    if (!root || root.__vsb) return;
    root.__vsb = true;
    var inst = {
      root: root,
      threshold: parseInt(root.dataset.thresholdCents || "50000", 10),
      fill: root.querySelector("[data-vsb-fill]"),
      amount: root.querySelector("[data-vsb-amount]"),
    };
    INSTANCES.add(inst);
    var initial = parseInt(root.dataset.initialSubtotalCents || "0", 10);
    renderInstance(inst, LAST_SUBTOTAL != null ? LAST_SUBTOTAL : initial);
  }

  function scanAndAttach() {
    document.querySelectorAll(".vikst-ship-bar").forEach(addInstance);
  }

  function hookOnce() {
    if (HOOKED) return;
    HOOKED = true;

    [
      "cart:updated",
      "cart:update",
      "cart:change",
      "product:added",
      "ajaxProduct:added",
      "cart-notification:updated",
      "cart-drawer:updated",
      "cart-drawer:open",
      "theme:cart:change",
      "theme:cart:update",
      "theme:cart:added",
      "shopify:section:load",
    ].forEach(function (ev) {
      document.addEventListener(ev, schedule);
    });

    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var body = init && typeof init.body === "string" ? init.body : "";
      var isCart = /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/.test(
        url,
      );
      var p = _fetch.apply(this, arguments);
      return p.then(function (res) {
        if (isCart) schedule();
        return res;
      });
    };

    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vsbURL = url ? url.toString() : "";
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener(
        "loadend",
        function () {
          if (
            /\/cart(\/(add|change|update|clear))?(\.js)?/.test(
              this.__vsbURL || "",
            )
          )
            schedule();
        }.bind(this),
      );
      return _send.apply(this, arguments);
    };

    new MutationObserver(function (muts) {
      for (var m of muts) {
        if (m.addedNodes && m.addedNodes.length) {
          scanAndAttach();
          break;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    fetchSubtotal();
  }

  var INSTANCES = new Set();
  var HOOKED = false;
  var PENDING = null;
  var LAST_SUBTOTAL = null;

  hookOnce();
  scanAndAttach();
  window[NS] = { refresh: schedule, rescan: scanAndAttach };
})();

// add to cart check
(function () {
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest("[data-js-product-add-to-cart]");
      if (!btn) return;

      // ── Bypass validation for pair-with quick buy ──
      if (btn.closest(".product-pair-with")) return;

      var errors = [];
      document.querySelectorAll(".gpo-app .pv-item").forEach(function (item) {
        if (window.getComputedStyle(item).display === "none") return;
        // Only required groups
        if (!item.querySelector(".gpo-label.required")) return;
        // GPO already marks it valid — trust it
        if (item.classList.contains("has-success")) return;
        // Radio buttons
        var radios = item.querySelectorAll('input[type="radio"]');
        if (radios.length) {
          if (!item.querySelector('input[type="radio"]:checked'))
            errors.push(item);
          return;
        }
        // Checkboxes — at least one must be checked
        var checkboxes = item.querySelectorAll('input[type="checkbox"]');
        if (checkboxes.length) {
          if (!item.querySelector('input[type="checkbox"]:checked'))
            errors.push(item);
          return;
        }
        // Select dropdown
        var select = item.querySelector("select");
        if (select) {
          if (!select.value || select.value === "") errors.push(item);
          return;
        }
      });

      if (!errors.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      // Open first unfilled group and scroll to it
      var first = errors[0];
      var header = first.querySelector(".pv-header");
      var body = first.querySelector(".pv-body");
      if (header && body) {
        header.setAttribute("aria-expanded", "true");
        body.classList.add("open");
      }
      first.scrollIntoView({ behavior: "smooth", block: "center" });
    },
    true,
  );
})();

// payment method

(function () {
  var descEl = document.querySelector(".product__description");
  var keys = ["Cut", "Style", "Texture", "Use"];
  var details = {};

  if (descEl) {
    descEl.querySelectorAll("strong").forEach(function (strong) {
      var key = strong.textContent.trim().replace(/:$/, "");
      if (keys.indexOf(key) === -1) return;
      var parent = strong.closest("p, li") || strong.parentElement;
      var value = parent.textContent.replace(strong.textContent, "").trim();
      if (value) details[key] = value;
    });
  }

  // Fill values + hide empty items
  var visibleCount = 0;
  document.querySelectorAll("[data-vikst-detail]").forEach(function (el) {
    var key = el.dataset.vikstDetail;
    if (details[key] && !el.textContent.trim()) el.textContent = details[key];
    var item = el.closest(".vikst-pd-item");
    if (!el.textContent.trim()) {
      item.style.display = "none";
    } else {
      visibleCount++;
    }
  });

  // Hide entire grid if no details found
  var grid = document.querySelector(".vikst-pd-grid");
  if (grid && visibleCount === 0) grid.style.display = "none";
})();

//
document.querySelectorAll(".product-pair-with--slider").forEach((slider) => {
  const track = slider.querySelector(".product-pair-with__track");
  const slides = slider.querySelectorAll(".product-pair-with__slide");
  const prev = slider.querySelector(".product-pair-with__prev");
  const next = slider.querySelector(".product-pair-with__next");
  const dotsWrap = slider.querySelector(".product-pair-with__dots");
  if (!track || !slides.length) return;

  let index = 0;
  const total = slides.length;
  const delay = 4000;
  let timer = null;
  let paused = false;

  if (dotsWrap && total > 1 && !dotsWrap.childElementCount) {
    slides.forEach((_, i) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "product-pair-with__dot";
      dot.setAttribute("aria-label", "Pairing " + (i + 1));
      dot.addEventListener("click", () => goTo(i));
      dotsWrap.appendChild(dot);
    });
  }

  const goTo = (i) => {
    if (total < 1) return;
    index = ((i % total) + total) % total;
    update();
    restart();
  };

  const update = () => {
    const slide = slides[index];
    if (!slide) return;
    track.style.transform = "translateX(-" + slide.offsetLeft + "px)";
    if (prev) prev.disabled = false;
    if (next) next.disabled = false;
    if (dotsWrap) {
      dotsWrap.querySelectorAll(".product-pair-with__dot").forEach((dot, i) => {
        dot.classList.toggle("is-active", i === index);
      });
    }
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const start = () => {
    stop();
    if (paused || total < 2) return;
    timer = setInterval(() => {
      goTo(index + 1);
    }, delay);
  };

  const restart = () => {
    if (!paused) start();
  };

  if (prev) prev.addEventListener("click", () => goTo(index - 1));
  if (next) next.addEventListener("click", () => goTo(index + 1));

  let startX = 0;
  let dragging = false;
  track.addEventListener(
    "touchstart",
    (e) => {
      startX = e.touches[0].clientX;
      dragging = true;
      paused = true;
      stop();
    },
    { passive: true },
  );
  track.addEventListener("touchend", (e) => {
    if (!dragging) return;
    dragging = false;
    const dx = e.changedTouches[0].clientX - startX;
    if (dx > 40) goTo(index - 1);
    else if (dx < -40) goTo(index + 1);
    paused = false;
    start();
  });

  slider.addEventListener("mouseenter", () => {
    paused = true;
    stop();
  });
  slider.addEventListener("mouseleave", () => {
    paused = false;
    start();
  });
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      stop();
    } else if (!paused) {
      start();
    }
  });

  window.addEventListener("resize", update);
  update();
  start();
});